import { useSocialAuthCallback } from './hooks/useSocialAuthCallback';

/**
 * 소셜 OAuth 콜백 착지 화면 (웹 전용).
 * 표시할 UI 없이 콜백을 처리하고 즉시 이동한다.
 */
export const AuthCallbackScreen = () => {
  useSocialAuthCallback();
  return null;
};
